// colorsData is an optional prefetch cache populated by snippets/algolia-
// collection.liquid on Algolia collection pages; on pages where that file
// isn't loaded (e.g. Tagalys collection pages) it's simply undefined here,
// and initColorVariants() below falls back to a live Algolia index search.
// Declared here (rather than left as an implicit global from algolia-
// collection.liquid) because this file - not that one - is what actually
// reads it, and it must exist wherever this file loads.
var colorsData;

window.initHomeBannerSlider = function(sliderId) {
  var id = sliderId.slice(sliderId.indexOf('#') + 1);
  var elSwiper = document.getElementById(id);
  if (!elSwiper || elSwiper.className.indexOf('swiper-container-initialized') !== -1) {
    return false;
  }
  function updateNavigationColor(swiper) {
    var slide = swiper.slides[swiper.activeIndex];
    var navPaginationContainer = swiper.$el.find('.wb-home-banner__nav-pagination-container');
    if (slide && swiper.$(slide).attr('data-swiper-slide-dark') === 'true') {
      navPaginationContainer.addClass('wb-home-banner__nav-pagination-container--dark');
    } else {
      navPaginationContainer.removeClass('wb-home-banner__nav-pagination-container--dark');
    }
  }
  return new Swiper(elSwiper, {
    on: {
      init: function () {
        var swiper = this;
        var removeSlideIndices = [];
        swiper.slides.each(function (index, slide) {
          if (swiper.$(slide).find('.wb-home-banner__item.wb-home-banner__item--dark').length > 0) {
            swiper.$(slide).attr('data-swiper-slide-dark', true);
          }
          if (window.getComputedStyle(slide).getPropertyValue('display') !== 'none') {
            return;
          }
          removeSlideIndices.push(parseInt(swiper.$(slide).attr('data-swiper-slide-index'), 10));
        });
        swiper.removeSlide(removeSlideIndices);
        swiper.update();
        if (swiper.slides.length - (swiper.loopedSlides * 2) < 2) {
          elSwiper.querySelector('.wb-home-banner__nav-pagination-container').style.display = 'none';
          swiper.allowTouchMove = false;
          swiper.allowSlidePrev = false;
          swiper.allowSlideNext = false;
          swiper.update();
        }
        updateNavigationColor(swiper);
      },
      slideChange: function() {
        var swiper = this;
        updateNavigationColor(swiper);
      }
    },
    navigation: {
      nextEl: sliderId + ' .wb-home-banner__nav-next',
      prevEl: sliderId + ' .wb-home-banner__nav-prev',
      disabledClass: 'wb-home-banner__nav--disabled',
      hiddenClass: 'wb-home-banner__nav--disabled'
    },
    pagination: {
      el: sliderId + ' .wb-home-banner__pagination',
      clickable: true,
      bulletClass: 'wb-home-banner__bullet',
      bulletActiveClass: 'wb-home-banner__bullet--active'
    },
    // Banners crossfade into each other instead of sliding sideways, so the
    // copy of the incoming banner can animate in over the new image
    // (Monday 3211257660, reference thrivin.com/en-de).
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    slidesPerView: 1,
    spaceBetween: 10,
    roundLengths: true, //prevent blurry text
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true,
      invert: true
    },
    autoplay: {
      delay: 8000,
    },
    speed: 700,
    loop: true,
    lazyLoad: true
  });
}
function ProductSliderItemsCount(sliderId , size) {
  console.log("sliderId",sliderId)
  switch (size) {
    case 992 :
      return sliderId.includes('recom_slider_sportswear--mixed-benner-reco') ? 1.75 : 3.5;
    case 1300 :
       return sliderId.includes('recom_slider_sportswear--mixed-benner-reco') ? 2.2 : 4;
    case 1600 :
      return sliderId.includes('recom_slider_sportswear--mixed-benner-reco') ? 2.5 : 4;
    default:
      return sliderId.includes('recom_slider_sportswear--mixed-benner-reco') ? 1.5 : 2.25;
  }
}
window.initProductSlider = function (sliderId) {
  var id = sliderId.slice(sliderId.indexOf('#') + 1);
  var elSwiper = document.getElementById(id);
    let slidesCount;
  try {
    slidesCount = elSwiper.querySelectorAll('.swiper-slide').length;
  } catch (e) {
    slidesCount = 0;
  }
  if (!elSwiper || elSwiper.className.indexOf('swiper-container-initialized') !== -1) {
    return false;
  }
  return new Swiper(elSwiper, {
    navigation: {
      nextEl: sliderId + ' + .wb-product-slider__nav .wb-product-slider__nav-next, ' + sliderId + ' > .wb-product-slider__nav .wb-product-slider__nav-next',
      prevEl: sliderId + ' + .wb-product-slider__nav .wb-product-slider__nav-prev, ' + sliderId + ' > .wb-product-slider__nav .wb-product-slider__nav-prev',
      disabledClass: 'wb-product-slider__nav--disabled',
      hiddenClass: 'wb-product-slider__nav--disabled'
    },
    slidesPerView: ProductSliderItemsCount(sliderId),
    spaceBetween: 10,
    roundLengths: true, //prevent blurry text
    freeMode: true,
    freeModeSticky: false,
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true,
      invert: true,
    },
    breakpoints: {
      992: {
        slidesPerView: ProductSliderItemsCount(sliderId , 992),
        scrollbar: {
           dragSize: 60,
        }
      },
      1300: {
        slidesPerView: ProductSliderItemsCount(sliderId , 1300),
        scrollbar: {
           dragSize: 60,
        },
      },
      1600: {
        slidesPerView: ProductSliderItemsCount(sliderId , 1600),
        scrollbar: {
          dragSize: 60,
        },
      },
    },
    loop: slidesCount >= 4,
    lazyLoad: true
  });
}

window.initHeaderTeasingSlider = function (elementOrSliderId) {
  let elSwiper;
  if (elementOrSliderId instanceof Element && elementOrSliderId.id === '') {
    elementOrSliderId.id = Array.from({length: 10}, () => String.fromCharCode(97+Math.floor(Math.random()*26))).join('');
    elSwiper = elementOrSliderId;
  }
  if (typeof elementOrSliderId === 'string') {
    elSwiper = document.getElementById(elementOrSliderId.slice(elementOrSliderId.indexOf('#') + 1));
  }
  if (!elSwiper || elSwiper.className.indexOf('swiper-container-initialized') !== -1) {
    return false;
  }

  function isSlideVisible(slide) {
    return window.getComputedStyle(slide).display !== 'none'
  }
  const visibleSlides = Array.from(elSwiper.querySelectorAll('.swiper-slide')).filter(isSlideVisible);
  const visibleSlidesCount = visibleSlides.length;
  if (visibleSlidesCount < 2) {
    if (visibleSlidesCount < 1) {
      elSwiper.style.display = 'none';
    }
    return false;
  }

  let config = {
    on: {
      init: function () {
        var swiper = this;
        var removeSlideIndices = [];
        swiper.slides.each(function (index, slide) {
          if (isSlideVisible(slide)) {
            return;
          }
          removeSlideIndices.push(parseInt(swiper.$(slide).attr('data-swiper-slide-index'), 10));
        });
        swiper.removeSlide(removeSlideIndices);
        swiper.update();
        let realSlideCount = swiper.params.loop ? swiper.slides.length - (swiper.loopedSlides * 2) : swiper.slides.length;
        if (realSlideCount <= 1) {
          swiper.params.loop = false;
          swiper.update();
          if (swiper.autoplay) {
            swiper.autoplay.stop();
          }
          if (realSlideCount < 1) {
            swiper.el.style.display = 'none';
          }
          swiper.allowTouchMove = false;
        }
      },
    },
    slidesPerView: 1,
    spaceBetween: 10,
    loop: visibleSlidesCount > 1,
    speed: 500,
    roundLengths: true, //prevent blurry text
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true,
      invert: true
    },
    autoplay: visibleSlidesCount > 1 ? {
      delay: 5000
    } : false
  };
  return new Swiper(elSwiper, config);
}

window.onQuickAddClicked = function (element, variantId, productHandle, productTitle, productImage) {
  var selectorContainer = '.wb-prdct20-fashion__quickadd-container',
      classActive = 'wb-quick-add__variants-item--active',
      classSuccess = 'wb-quick-add__success',
      classAdding = 'wb-quick-add__success--adding',
      classAdded = 'wb-quick-add__success--added';
  if (element.classList.contains(classActive)) {
    return;
  }
  var elContainer = element.closest(selectorContainer);
  var gtmContext = element.closest('[data-gtm-context]')?.getAttribute('data-gtm-context') || 'quickadd';
  //elContainer.style.opacity = 1;
  element.classList.add(classActive);
  var addToCartData = { id: variantId, quantity: 1 };
  if (Cookies.get('adfb') !== undefined){
  addToCartData = { id: variantId,
                   quantity: 1,
                   properties: {'ad': 'FB'}
                  };
  }else if(Cookies.get('adig') !== undefined){
     addToCartData = { id: variantId,
                   quantity: 1,
                   properties: {'ad': 'IG'}
                  };
  }

  /*
  var shippingDiscount = Cookies.get('WBShippingDiscount');
  if (shippingDiscount && document.documentElement.classList.contains('wb-us')) {
    addToCartData.properties = addToCartData.properties || {};
    addToCartData.properties._shipping_discount = shippingDiscount;
  }
  */
  if (typeof window.transformAppAddToCartData !== 'undefined') {
    addToCartData = window.transformAppAddToCartData(addToCartData);
  }

  axios.post('/cart/add.json', addToCartData)
  .then(function (response) {
    //console.log('quick add product', variantId);
    var circleSvg = '<svg class="wb-quick-add__success--circle" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="25"></circle></svg>';
    var loadingSvg = '<svg class="wb-quick-add__success--check" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg"><polyline points="11.6,20 15.9,24.2 26.4,13.8"></polyline></svg>';
    var domString = '<div class="' + classSuccess + '">' + circleSvg + loadingSvg + '</div>';
    var parser = new DOMParser();
    var elSuccess = parser.parseFromString(domString, 'text/html').body.firstChild;
    if(window.Cookies.get('special-offer') !== undefined){
            window.WBupdateCartNote('special-offer');
    }
    document.dispatchEvent(new CustomEvent('wb:addtocartsuccess', { detail: { quickadd: true, handle: productHandle, title: productTitle, image: productImage } }));

      // GTM tracking
      window.callGTMTracking(gtmContext);

      vueapp.loadCart();
      // vueapp.eeAddToCart(product, index);
      document.dispatchEvent(new CustomEvent('wb:checkloadedcartItems'));

      if (typeof AppUserAgentDetected !== 'undefined' && AppUserAgentDetected) {
        bottomCartMessage.show();
      } else if(!window.location.pathname.includes('/cart') && typeof sidecart !== 'undefined') {
        sidecart._data.show = true;
      }
      if (element.closest('.wb-cart-tabs-container') && window.location.pathname.indexOf('/cart') !== -1) {
        vueapp.$scrollTo({el: '#cartform', duration: 1000});
      }

    element.appendChild(elSuccess);
    elSuccess.classList.add(classAdding);
    setTimeout(function () {
      elSuccess.classList.add(classAdded);
      setTimeout(function () {



        //document.dispatchEvent(new CustomEvent('wb:addtocartsuccess', { detail: { quickadd: true, handle: productHandle, title: productTitle, image: productImage } }));


          elSuccess.classList.remove(classAdding);
          elSuccess.classList.remove(classAdded);
          element.classList.remove(classActive);

        /*
        window.wbHeader.showCartCheck(element, function () {
          elSuccess.classList.remove(classAdding);
          elSuccess.classList.remove(classAdded);
          setTimeout(function () {
            element.removeChild(elSuccess);
            element.classList.remove(classActive);
            elContainer.style.opacity = null;
          }, 225);
        }, true);
        */
      }, 225);
    }, 1000);

    const isInSearchResult =  element.parentElement?.parentElement?.getAttribute('data-is-search') ?? 
                              element.parentElement?.parentElement?.parentElement?.getAttribute('data-is-search');
       

        if (isInSearchResult){
          var algoliaEventData = {
            userToken: window.getUserUuid(), 
            eventName: 'Added To Cart ObjectIDs After Search',
            index: window.algoliaIndex,
            queryID: window.lastQueryID,
            objectIDs: [response.data.id.toString()]
          };
       
        Shopify.analytics.publish("algolia_addedToCartObjectIDsAfterSearch", algoliaEventData);
        window.localStorage.setItem('algoliaConversionAfterSearch', window.getUserUuid());
        window.localStorage.setItem('algoliaConversionAfterSearchQuery', window.lastQueryID);
        window.localStorage.setItem('algoliaConversionIndexAfterSearch', window.algoliaIndex);
        }
  })
  .catch(function (error) {
    console.log(error);
   element.classList.remove(classActive);
    elContainer.style.opacity = null;
  });
}

window.onQuickAddToggle = function (element) {
  element.classList.toggle('wb-quick-add__toggle--active');
  $(element.nextElementSibling).slideToggle(225);
}

document.addEventListener('DOMContentLoaded', function () {
  var homeBanners = document.querySelectorAll('.swiper-container.wb-home-banner[id^="home_banner"]');
  homeBanners.forEach(homeBanner => {
    window.initHomeBannerSlider('#' + homeBanner.id);
  });
  
  var recomSliders = document.querySelectorAll('.swiper-container.wb-product-slider__swiper[id^="recom_slider"]');
  recomSliders.forEach(recomSlider => {
    window.initProductSlider('#' + recomSlider.id);
  });
  // setTimeout(function () {
  //   window.initProductSlider('#newin_slider_sportswear');
  //   window.initProductSlider('#newin_slider');
  // }, 400);

function elementInViewport(el) {
  var top = el.offsetTop;
  var left = el.offsetLeft;
  var width = el.offsetWidth;
  var height = el.offsetHeight;

  while(el.offsetParent) {
    el = el.offsetParent;
    top += el.offsetTop;
    left += el.offsetLeft;
  }

  return (
    top >= window.pageYOffset &&
    left >= window.pageXOffset &&
    (top + height) <= (window.pageYOffset + window.innerHeight) &&
    (left + width) <= (window.pageXOffset + window.innerWidth)
  );
}

  var swiperElement = document.getElementById('home_banner');
  var swiperElementRestock = document.getElementById('home_banner_restock');
  var swiperElementFashionIndex = document.getElementById('home_banner--fashion-index');
  if(swiperElement != undefined){
  var interval = setInterval(function(){
          if(elementInViewport(swiperElement)){
            window.initHomeBannerSlider('#home_banner');
             clearInterval(interval);
           }
      }, 500);
  }
  if(swiperElementRestock != undefined){
  var intervalRestock = setInterval(function(){
          if(elementInViewport(swiperElementRestock)){
            window.initHomeBannerSlider('#home_banner_restock');
             clearInterval(intervalRestock);
           }
      }, 500);
  }

  if(swiperElementFashionIndex != undefined){
  var intervalFashionIndex = setInterval(function(){
          if(elementInViewport(swiperElementFashionIndex)){
            window.initHomeBannerSlider('#home_banner--fashion-index');
             clearInterval(intervalFashionIndex);
           }
      }, 500);
  }



  setTimeout(function () {
    if (window.initCabSlider) {
      window.initCabSlider();
    }
  }, 500);


  try {
   var sections = $('.product-index--reco-fitness-tabs');
  

    function clickTab() {
       var section = $(this).closest('.product-index--reco-fitness-tabs'); 
    var tabs = section.find('label');
      var activeTab = section.find('label.checked');
      var activePosition = activeTab.data('position');
      var nextPosition = $(this).data('position');
      var nextTab = section.find('label[data-position=' + nextPosition + ']');

      var activeReco = section.find('.product-swiper-wrapper[data-position="'+activePosition+'"]');
      var nextReco = section.find('.product-swiper-wrapper[data-position='+ nextPosition + ']');

      section.attr('data-position', nextPosition);
      activeTab.toggleClass('checked');
      nextTab.toggleClass('checked');

      var nextSwiperContainer = nextReco.find('.swiper-container');
      if (nextSwiperContainer.length > 0 && nextSwiperContainer.get(0).swiper) {
        nextSwiperContainer.get(0).swiper.update();
      }
      if (window.equalHeightInstance) {
        equalHeightInstance.update();
      }
    }

     function init() {
    sections.each(function() {
      var section = $(this);
      var tabs = section.find('label');
      tabs.on('click', clickTab);
    });
  }
    init()
} catch (error) {
  
}
}, { passive: true });


window.orderAgain = function (element,variantId, productHandle,productTitle,productImage) {

  var gtmContext = element.closest('[data-gtm-context]')?.getAttribute('data-gtm-context') || 'order-again';
  var addToCartData = { id: variantId, quantity:1};

  if (typeof window.transformAppAddToCartData !== 'undefined') {
    addToCartData = window.transformAppAddToCartData(addToCartData);
  }

  axios.post('/cart/add.json', addToCartData)
  .then(function (response) {

    document.dispatchEvent(new CustomEvent('wb:addtocartsuccess', { detail: { quickadd: true, handle: productHandle, title: productTitle, image: productImage } }));
    document.dispatchEvent(new CustomEvent('wb:addtocarttracking', { detail: { sku: response.data.sku, qty: '1', prodID: response.data.product_id, variantID: response.data.variant_id } }));

    // GTM tracking
    window.callGTMTracking(gtmContext);

    setTimeout(() => {
        if(!window.location.pathname.includes('/cart') && typeof sidecart !== 'undefined') {
          sidecart._data.show = true;
          vueapp.loadCart();
        }
      }, 100);
  })

  .catch (function (error) {

    document.dispatchEvent(new CustomEvent('wb:alert', {detail: {element:element}}));

  })


}

window.callGTMTracking = function (context) {
  //console.log("----context-----",context)
  window.localStorage.setItem('lastAddToCartContext', context);
}

window.onQuickAddSizeClicked = function (element, productId, productHandle) {
  var selectorContainer = '.wb-prdct20-fashion__quickadd-container',
    selectorItem = '.wb-quick-add__variants-item',
    selectorSizeItem = '.wb-quick-add__variants-size-wrapper .wb-quick-add__variants-item',
    selectorLengthTitle = '.wb-quick-add__title-length',
    selectorLengthWrapper = '.wb-quick-add__variants-length-wrapper',
    classSoldout = 'wb-quick-add__variants-item--soldout',
    classActive = 'wb-quick-add__variants-item--active',
    selectorItemActive = '.wb-quick-add__variants-item.wb-quick-add__variants-item--active';
  var elContainer = element.closest(selectorContainer);
  var size = element.dataset.quickaddSize.toLowerCase();
  var variants = JSON.parse(elContainer.dataset.variants).filter(function (variant) { return variant.title.toLowerCase().indexOf(size + ' -') === 0; });
  var elLengthWrapper = elContainer.querySelector(selectorLengthWrapper);
//console.log(JSON.parse(elContainer.dataset.variants))
  
  Array.prototype.slice.call(elLengthWrapper.querySelectorAll(selectorItem)).forEach(function (el) {
    var length = el.dataset.quickaddLength.toLowerCase();
    var variant = variants.filter(function (variant) { return variant.title.toLowerCase().indexOf('- ' + length) !== -1; })[0];
    if (!variant) {
      el.style.display = 'none';
      return;
    }
    el.style.display = null;
    // Fill the {size} placeholder in the revealed length/logo button's aria-label
    // now that a concrete size has been chosen.
    if (el.dataset.ariaSizeTemplate) {
      el.setAttribute('aria-label', el.dataset.ariaSizeTemplate.replace('{size}', element.dataset.quickaddSize.toUpperCase()));
    }
    var elSvg = el.querySelector('svg');
    if (!variant.available) {
      el.classList.add(classSoldout);
      el.setAttribute('disabled', true);
      elSvg.style.display = null;
      el.removeAttribute('data-quickadd-variant-id');
      return;
    }
    //console.log(variant)
    el.classList.remove(classSoldout);
    el.removeAttribute('disabled');
    elSvg.style.display = 'none';
    el.setAttribute('data-quickadd-variant-id', variant.id);

  });

  Array.prototype.slice.call(elContainer.querySelectorAll(selectorSizeItem)).forEach(function (el) { el.classList.remove(classActive); });
  //console.log(Array.prototype.slice.call(elContainer.querySelectorAll(selectorSizeItem)))
  element.classList.add(classActive);
  var elLengthTitle = elContainer.querySelector(selectorLengthTitle);

  // Reveal the length row once a size is picked. Two markups hide it
  // differently: the Tagalys grid uses display:none (reveal via display); the
  // Algolia grid (all non-IE shops) uses position:absolute; z-index:-1 (reveal
  // by clearing those). Do both so quick-add length selection works on every shop.
  elLengthTitle.style.display = '';
  elLengthTitle.style.position = null;
  elLengthTitle.style.zIndex = null;
  elLengthWrapper.style.display = 'flex';
  elLengthWrapper.style.position = null;
  elLengthWrapper.style.zIndex = null;
}
window.onQuickAddLengthClicked = function (element, productHandle, productTitle, productImage) {
  var variantId = element.dataset.quickaddVariantId;
  if (!variantId) { return; }
  window.onQuickAddClicked(element, variantId, productHandle, productTitle, productImage);
}

function selectFilterProductsBySize(sizeType, element) {
  var inputElement = document.getElementById('variant-id');
  inputElement.value = '';
  var section = element.closest('.product-size-section');

  var variants = section.querySelectorAll('.wb-product--logovariant');
  variants.forEach(function(variant) {
    variant.classList.remove('active');
  });

  element.classList.add('active');

  filterProductsBySize(sizeType, section);
}

function filterProductsBySize(sizeType, section) {
  const regularItems = section.querySelectorAll('.regular');
  const sevenEightItems = section.querySelectorAll('.seven-eight');
  const shortItems = section.querySelectorAll('.short');
  const longItems = section.querySelectorAll('.long');
  const regularContent = document.querySelectorAll('.regular-size-content');
  const sevenEightContent = document.querySelectorAll('.seven-eight-size-content');
  const shortContent = document.querySelectorAll('.short-size-content');
  const longContent = document.querySelectorAll('.long-size-content');
  const toggleDisplay = (items, content, displayStyle, isActive) => {
    items.forEach(item => {
      item.style.display = displayStyle;
      if (isActive) {
        //item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });
    content.forEach(item => {
      item.style.display = displayStyle;
    });
  };
  toggleDisplay(regularItems, regularContent, 'none', false);
  toggleDisplay(shortItems, shortContent, 'none', false);
  toggleDisplay(longItems, longContent, 'none', false);
  toggleDisplay(sevenEightItems, sevenEightContent, 'none', false);
  if (sizeType === 'Regular') {
    toggleDisplay(regularItems, regularContent, '', true);
  } else if (sizeType === 'Short') {
    toggleDisplay(shortItems, shortContent, '', true);
  } else if (sizeType === 'Long') {
    toggleDisplay(longItems, longContent, '', true);
  } else if (sizeType === '7/8') {
    toggleDisplay(sevenEightItems, sevenEightContent, '', true);
  }
}


// Text going into a double-quoted HTML attribute value.
function escapeAttr(value){
  return String(value === null || value === undefined ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

// A value interpolated into a JS string literal that itself sits inside an HTML attribute has
// to survive both layers, and the swatch rails below build their hover handlers exactly that
// way. JSON.stringify closes the JS layer — quotes, backslashes, newlines — and brings its own
// surrounding quotes; escapeAttr then closes the attribute layer. Colour names come from the
// product title, so an apostrophe in one is ordinary: "Nature's Green" used to emit
// onmouseover="writeColorNameHower( 'Nature's Green' , ...)", which does not compile, so the
// swatch wrote no colour name on hover and logged a SyntaxError on every pointer pass. A
// double quote in a name broke out of the attribute altogether.
function jsStringAttr(value){
  return escapeAttr(JSON.stringify(String(value === null || value === undefined ? '' : value)));
}

function createHtml(variant,isShowPicturePDP,colorName,element="",isActive,isLimited=false){
  // Plain link on the PDP: pdp-color-switch.js delegates the click from document and switches
  // colour in place, so no per-swatch handler is interpolated here. The href stays the real
  // product url — cmd/middle-click, no-JS and crawlers all still get a normal navigation.
  // jsStringAttr, not a hand-written pair of quotes: this is a value inside a JS string
  // literal inside an HTML attribute, the same two layers the hover handlers below go
  // through, so it needs the same escaping to survive both.
  const changeColorAttr = element === "-sidebar"
    ? `onclick="sidebar.fashionColorChange(${jsStringAttr(variant.handle)})"`
    : `href="/products/${escapeAttr(variant.handle)}"`;
  let itemHtml
  if(isShowPicturePDP){
    let variantImage = variant.product_image;
    if (variant.tags.includes('colorvariant:4')) {
      variantImage = variant.images ? variant.images[3] : variant.product_image;
    } else if (variant.tags.includes('colorvariant:3') || variant.tags.includes('colorvariant:2')) {
      variantImage = variant.images ? variant.images[2] : variant.product_image;
    } else if (variant.tags.includes('colorvariant:5')) {
      variantImage = variant.images ? variant.images[4] : variant.product_image;
    }
    /*@click="sidebar.fashionColorChange(color.split('|')[1])" -sidebar*/

    itemHtml = `
              <div class="item${!variant.inventory_available ? ' item--sold-out' : ''} ${isActive ? ' active' : ''}">
                <a id="variant-${escapeAttr(variant.handle)}"
                   class=" wb-picture-wrapper"
                    ${changeColorAttr}
                   title="${escapeAttr(colorName)}">
                       ${!variant.inventory_available && !isShowPicturePDP ? `<svg  style="width: 100%; height: 100%; position: absolute; top: 0; bottom: 0; left: 0; right: 0; inset: 0;" fill="currentColor" stroke="currentColor">
                      <line x1="0" y1="100%" x2="100%" y2="0" style="stroke-width:1"></line>
                    </svg>` : ''}
                  <canvas class="wb-picture__canvas" width="1440" height="1800"></canvas>
                  <picture>
                    <source data-srcset="${escapeAttr(variantImage)}?width=200 1x, ${escapeAttr(variantImage)}?width=400 2x">
                    <img class="wb-picture__img wb-picture__img--cover lazy"
                         data-src="${escapeAttr(variantImage)}?width=200"
                         alt="${escapeAttr(variant.title)}">
                  </picture>
                </a>
              </div>
            `;
  }else{

    itemHtml = `
            <div class="sidebar--color-item-box" onmouseover="writeColorNameHower(${jsStringAttr(colorName)} , ${jsStringAttr(element)} , true , ${isLimited})" onmouseout="writeColorNameHower(${jsStringAttr(colorName)} , ${jsStringAttr(element)}, false , ${isLimited})">  <a   ${changeColorAttr} style="order: 0;position: relative"  class="sidebar--color-item m-b-0 ${isActive ? ' active' : ''}" aria-label="${escapeAttr(colorName)}">
                   
                <div style="position: relative;" class="sidebar--color-item-bg ${!variant.inventory_available ? ' item--sold-out' : ''}"
           
                     data-handle="${escapeAttr(variant.handle)}" data-bgcolor="${escapeAttr(colorName)}"
                     >
                     ${!variant.inventory_available && !isShowPicturePDP ? `<svg  style="color:white;width: 100%; height: 100%; position: absolute; top: 0; bottom: 0; left: 0; right: 0; inset: 0;" fill="currentColor" stroke="currentColor">
                      <line x1="0" y1="100%" x2="100%" y2="0" style="stroke-width:1"></line>
                    </svg>` : ''}
                     
                </div>
              </a><div class="sidebar--color-item-text m-b-5">${variant.tags && variant.tags.includes('new') ? 'New' : ''}</div></div>
            `;
  }
  return itemHtml;
}
function createLoadMore(count,isLimited=false,element = "")
{
  return `<div class="wb-fashion-show-more-color" id="${isLimited?'wb-fashion-show-more-limited-color'+element:'wb-fashion-show-more-color'+element}">
    <div class="">
      <span>+${count}</span>
      <div
        class="wb-fashion-show-more-txt smaller">Colors</div>
    </div>
  </div>`
}
function ActiveLoadMore(count,isLimited=false,element = "")
{
  // console.log("ActiveLoadMore",count,isLimited,element)
  let productsContainer
  let showMoreBtn
  if(isLimited){
    productsContainer = document.getElementById('fashion-color-limited-switch'+element);
    showMoreBtn = document.getElementById('wb-fashion-show-more-limited-color'+element);
  }else{
    productsContainer = document.getElementById('fashion-color-switch'+element);
    showMoreBtn = document.getElementById('wb-fashion-show-more-color'+element);
  }
  // console.log("productsContainer",productsContainer,showMoreBtn)
  const allItems = Array.from(productsContainer.getElementsByClassName('item'));
  const itemsPerRow = 6;
  const visibleRows = 3;
  const initialVisibleItems = (itemsPerRow * visibleRows)-1;
  if(allItems.length<= initialVisibleItems){
    // showMoreBtn.style.display = 'none';
    return
  }
//  console.log("allItems",allItems)
  const calculateHeightForItems = (itemsCount) => {
    let height = allItems[0].offsetHeight+4
    return height * (itemsCount/itemsPerRow);
    productsContainer.style.overflow = ''
  };
  const initialHeight = calculateHeightForItems(initialVisibleItems+1);
  productsContainer.style.height = `${initialHeight}px`;
// console.log("initialHeight",initialHeight)
  showMoreBtn.addEventListener('click', () => {
    const fullHeight = calculateHeightForItems(allItems.length);
    // console.log("fullHeight",fullHeight)
    productsContainer.style.height = `${fullHeight}px`;
    showMoreBtn.style.display = 'none';

    productsContainer.style.overflow = '';
    setTimeout(()=>{
      productsContainer.style.height = `auto`;
    },220)
  });
}
function renderLimitedEditionVariants(variants, isShowPicturePDP, productHandle, productTitle, element = "") {
  const currentProduct = productHandle;
  const isCurrentProductLimited = variants.some(v => v.handle === currentProduct);


  const limitedEditionHtml = `
          ${variants.map((variant, index) => {
    if (variant.handle === productHandle && element != "-sidebar") return;
    const titleParts = variant.title.split('|');
    const colorName = titleParts[1] ? titleParts[1].trim() : '';
    const isActive = variant.handle === currentProduct;
    if(variants.length>18 && isShowPicturePDP && index==17){
      let colorSwitch = document.getElementById('fashion-color-limited-switch'+element);
      colorSwitch.insertAdjacentHTML('beforeend', createLoadMore(variants.length-17,true,element ));

    }
    return createHtml(variant,isShowPicturePDP,colorName,element,variant.handle === productHandle,true);
  }).join('')}`;


  if (variants.length > 0) {
    document.querySelectorAll('.is-not-limited'+element).forEach(function(element) {
      element.classList.remove('d-none');
    });
    document.querySelectorAll('.is-limited'+element).forEach(function(element) {
      element.classList.add('d-none');
    });
    let colorSwitch = document.getElementById('fashion-color-limited-switch'+element);
    colorSwitch.insertAdjacentHTML('beforeend', limitedEditionHtml);
    if(variants.length>18 && isShowPicturePDP){
      ActiveLoadMore(variants.length,true,element)
    }
  }else{
    document.querySelectorAll('.is-not-limited'+element).forEach(function(element) {
      element.classList.add('d-none');
    });

    document.querySelectorAll('.is-limited'+element).forEach(function(element) {
      element.classList.remove('d-none');
    });
  }


}

function renderColorVariants(variants , isShowPicturePDP,productHandle,element="") {
  const currentProduct = productHandle;
  const colorSwitch = document.getElementById('fashion-color-switch'+element);
  if (!colorSwitch) return;
  const items = colorSwitch.querySelectorAll('.item:not(:first-child)');
  items.forEach(item => item.remove());
  let itemHtml="";
  variants.forEach((variant,index) => {
    if (variant.handle === productHandle && element != "-sidebar") return;
    const titleParts = variant.title.split('|');
    const colorName = titleParts[1] ? titleParts[1].trim() : '';
    if(variants.length>18 && isShowPicturePDP && index==17){
      colorSwitch.insertAdjacentHTML('beforeend', createLoadMore(variants.length-17,false,element ));
    }
    colorSwitch.insertAdjacentHTML('beforeend', createHtml(variant,isShowPicturePDP,colorName,element , variant.handle === productHandle,false));
  });
  if(variants.length>18 && isShowPicturePDP ){
    ActiveLoadMore(variants.length,false,element)
  }
  // Cache-warming is intent-based now: pdp-color-switch.js prefetches a colour when the
  // shopper hovers/focuses/taps its swatch, so we no longer eagerly fetch the whole family
  // on load (that speculative request competed with LCP resources for shoppers who never
  // switched). See onSwatchIntent in pdp-color-switch.js.
  //  updateLazyLoad();
//    updateCurrentVariantTitle(variants);
  //   initializeColorSwitch();
}


// Storefront-API replacement for the Algolia lookup below - used whenever
// this runs on a Tagalys page (window.wbTagalysCollection), since Tagalys
// pages never initialize Algolia (no window.wbAlgolia.activeIndex, no
// algolia-collection.liquid), so the Algolia branch below was creating a
// brand new client with IE's Algolia credentials on every quick-add open
// and failing silently. Returns the same "hit" shape separateVariants/
// renderColorVariants/renderLimitedEditionVariants already expect (handle,
// title, tags, inventory_available, plus images/featured_image for the
// isShowPicturePDP case), built from a top-level Storefront product search
// (no collection context needed) instead of an Algolia index search.
async function wbFetchColorVariantsViaStorefront(baseTitle) {
  if (!window.WBStorefrontApi) {
    return [];
  }
  var query = 'query($q: String!) {' +
    ' products(first: 100, query: $q) {' +
    '  edges { node { handle title tags availableForSale featuredImage { url } images(first: 6) { edges { node { url } } } } }' +
    ' }' +
    '}';
  var escapedTitle = String(baseTitle || '').replace(/"/g, '\\"');
  var searchQuery = "tag:'color-sorting' AND title:'" + escapedTitle + "*'";
  return window.WBStorefrontApi.fetch(query, { q: searchQuery }).then(function (data) {
    var edges = data && data.products && data.products.edges;
    if (!edges) {
      return [];
    }
    return edges.map(function (edge) {
      var node = edge.node;
      var images = (node.images && node.images.edges || []).map(function (imgEdge) {
        return imgEdge.node.url;
      });
      return {
        handle: node.handle,
        title: node.title,
        tags: node.tags || [],
        inventory_available: node.availableForSale !== false,
        product_image: node.featuredImage ? node.featuredImage.url : '',
        images: images
      };
    });
  }).catch(function (error) {
    console.error('Tagalys quick-add: color variant fetch failed', error);
    return [];
  });
}

async function initColorVariants(productTitle,isShowPicturePDP,productHandle,algoliaAppId,algoliaApiKey,algoliaIndex,element="") {
 // console.log("algoliaAppId",algoliaAppId)
  let index
  let selectedColorData
  let response

  // Colour-swatch source on Tagalys (IE) pages is switchable via
  // tagalys-settings.liquid -> tagalys_color_source (exposed as
  // window.wbTagalysConfig.colorSource). "storefront" keeps the Shopify
  // Storefront tag search (no curated order); anything else (default
  // "algolia") uses the Algolia color-sorting search below for the curated
  // order, with an automatic Storefront fallback so swatches never go blank.
  // Non-Tagalys pages always use Algolia.
  var tagalysColorSource = (window.wbTagalysConfig && window.wbTagalysConfig.colorSource) || 'algolia';
  if (window.wbTagalysCollection && tagalysColorSource === 'storefront') {
    try {
      response = await wbFetchColorVariantsViaStorefront(productTitle[0].trim());
      if (response) {
        const { regularVariants, limitedVariants } = separateVariants(response);
        renderLimitedEditionVariants(limitedVariants,isShowPicturePDP,productHandle,productTitle,element);
        renderColorVariants(regularVariants,isShowPicturePDP,productHandle,element);
      }
    } catch (error) {
      console.error('Error fetching color variants:', error);
    }
    return;
  }

  try {

    try {
      if(!window?.wbAlgolia?.activeIndex){
        const client = algoliasearch(algoliaAppId,algoliaApiKey);
        index = client.initIndex(algoliaIndex);
      }else{
        index = window?.wbAlgolia?.activeIndex
      }

      if(element == "-sidebar"){
        // console.log("bef filt",response)
        // response = response.hits.filter(hit => hit.inventory_available)

        if(colorsData){
           selectedColorData = findFirstMatchingParent(colorsData , productTitle[0].trim())
        }
        if(selectedColorData){
          response = selectedColorData?.hits
        }else{
           response = await index.search('', {
            filters: `tags:color-sorting AND meta.custom.title:'${productTitle[0].trim()}'`,
            ruleContexts:['color-sorting'],
            hitsPerPage: 1000,
          });
          response = await window.transformAppAlgoliaSearchResponse(response);
          response = await window.transformPreviewLaunchTagAlgoliaSearchResponse(response);
          response = response?.hits
        }

        //  console.log("after filt",response)
      }else{
         response = await index.search('', {
          filters: `tags:color-sorting AND meta.custom.title:'${productTitle[0].trim()}'`,
          ruleContexts:['color-sorting'],
          hitsPerPage: 1000,
        });
        response = await window.transformAppAlgoliaSearchResponse(response);
        response = await window.transformPreviewLaunchTagAlgoliaSearchResponse(response);
        response = response?.hits
      }
    } catch (algoliaError) {
      // Algolia not usable on this page - fall through to the Storefront fallback below.
      console.warn('Algolia colour lookup failed; using Storefront fallback', algoliaError);
      response = null;
    }

    // Tagalys pages: if Algolia returned nothing, fall back to the Storefront
    // tag search so swatches still render (the safety net the dedicated
    // Tagalys branch used to provide).
    if ((!response || !response.length) && window.wbTagalysCollection) {
      response = await wbFetchColorVariantsViaStorefront(productTitle[0].trim());
    }

    if ( response) {

      const { regularVariants, limitedVariants } = separateVariants(response);
      renderLimitedEditionVariants(limitedVariants,isShowPicturePDP,productHandle,productTitle,element);
      renderColorVariants(regularVariants,isShowPicturePDP,productHandle,element);

    }
  } catch (error) {
    console.error('Error fetching color variants:', error);
  }
}
function createFirstElement(isShowPicturePdp, product, fashiontitleParts,element="") {
  let itemHtml = "";
  let colorSwitch;
  const isLimited = product.tags.includes('limited-edition');
  const colorName = fashiontitleParts[1].trim();

  if (isShowPicturePdp) {
    let colorVariantImgMain = product.featured_image;
    if (product.tags.includes('colorvariant:4')) {
      colorVariantImgMain = product.images[3].src;
    } else if (product.tags.includes('colorvariant:3')) {
      colorVariantImgMain = product.images[2].src;
    } else if (product.tags.includes('colorvariant:2')) {
      colorVariantImgMain = product.images[2].src;
    } else if (product.tags.includes('colorvariant:5')) {
      colorVariantImgMain = product.images[4].src;
    }
    itemHtml = `<div class="item active">
          <a id="variant-${escapeAttr(product.handle)}"
             class="wb-picture-wrapper"
             href="${escapeAttr(product.url)}"
             title="${escapeAttr(colorName)}">
            <canvas class="wb-picture__canvas" width="1440" height="1800"></canvas>
            <picture>
              <source data-srcset="${escapeAttr(colorVariantImgMain)}?width=200&height=200&scale=1 1x, ${escapeAttr(colorVariantImgMain)}?width=200&height=200&scale=2 2x">
                <img class="wb-picture__img wb-picture__img--cover lazy"
                     data-src="${escapeAttr(colorVariantImgMain)}?width=200&height=200"
                     alt="${escapeAttr(product.title)}">
            </picture>
          </a>
        </div>`;

  } else {

    // Carries the same hover handlers createHtml puts on every other swatch box. Without
    // them this was the one swatch in the rail that wrote no colour name on hover — which
    // stayed invisible for as long as it was permanently the active swatch: its name was
    // already in the title, and the only way to leave it was a full page reload that
    // re-rendered the rail. pdp-color-switch.js now switches colour in place, so this
    // element survives the switch, stops being active, and the gap is visible.
    itemHtml = `<div class="sidebar--color-item-box" onmouseover="writeColorNameHower(${jsStringAttr(colorName)} , ${jsStringAttr(element)} , true , ${isLimited})" onmouseout="writeColorNameHower(${jsStringAttr(colorName)} , ${jsStringAttr(element)}, false , ${isLimited})"><a href="/products/${escapeAttr(product.handle)}" class="sidebar--color-item m-b-0 active" aria-label="${escapeAttr(colorName)}"><div class="sidebar--color-item-bg"  data-handle="${escapeAttr(product.handle)}" data-bgcolor="${escapeAttr(colorName)}"></div></a><div class="sidebar--color-item-text m-b-5">${product.tags.includes('new') ? 'New' : ''}</div></div>`;
  }
  document.getElementById('fashion-color-limited-switch'+element).innerHTML="";
  document.getElementById('fashion-color-switch'+element).innerHTML="";
  if (isLimited) {
    colorSwitch = document.getElementById('fashion-color-limited-switch'+element);
    document.getElementById('limited-color-text'+element).innerHTML = ' '+colorName;
    document.getElementById('regular-color-text'+element).innerHTML = '';
  } else {
    colorSwitch = document.getElementById('fashion-color-switch'+element);
    document.getElementById('limited-color-text'+element).innerHTML = '';
    document.getElementById('regular-color-text'+element).innerHTML = ' '+colorName;
  }
  if(element == "-sidebar"){return}
  colorSwitch.insertAdjacentHTML('beforeend', itemHtml);
}
function separateVariants(variants) {
  const regularVariants = [];
  const limitedVariants = [];

  variants.forEach(variant => {
    if (variant.tags.includes('limited-edition')) {
      limitedVariants.push(variant);
    } else {
      regularVariants.push(variant);
    }
  });

  return { regularVariants, limitedVariants };
}
function writeColorNameHower(colorName,element,status,isLimited=false){
  //console.log("00000",isLimited)
  if(status){
    if(!isLimited){
      document.getElementById('fashion-color-switch-item-title'+element).innerHTML =` ${colorName}`;
      document.getElementById('regular-color-text'+element).innerHTML =` ${colorName}`;
    }else{
      document.getElementById('limited-color-text'+element).innerHTML =` ${colorName}`;

    }

  }else{
    if(!isLimited){
      var color_switch_slider = document.getElementById('fashion-color-switch'+element);
      var color_items = Array.prototype.slice.call(color_switch_slider.querySelectorAll('.sidebar--color-item-box .active .sidebar--color-item-bg '));
      var current_title = color_items[0]?.getAttribute('data-bgcolor');
      //console.log("1111111",current_title)
      document.getElementById('fashion-color-switch-item-title'+element).innerHTML = current_title !== undefined ? ` ${current_title}` : ' ';
      document.getElementById('regular-color-text'+element).innerHTML = current_title !== undefined ? ` ${current_title}` : ' ';
      //  console.log("22222222",current_title)
    }else{
      var color_switch_slider = document.getElementById('fashion-color-limited-switch'+element);
      var color_items = Array.prototype.slice.call(color_switch_slider.querySelectorAll('.sidebar--color-item-box .active .sidebar--color-item-bg '));
      var current_title = color_items[0]?.getAttribute('data-bgcolor');
     // console.log("999999",current_title)
      document.getElementById('limited-color-text'+element).innerHTML = current_title !== undefined ? ` ${current_title}` : ' ';
      // console.log("33333333",current_title)
    }

  }

}

function changeActiveColor(handle, element, isShowPicturePdp,isLimited) {
  var color_switch_slider_el
  var other_color_switch_slider_el
  if(isLimited){
     color_switch_slider_el = document.getElementById('fashion-color-limited-switch'+element);
    other_color_switch_slider_el = document.getElementById('fashion-color-switch'+element);
  }else{
     color_switch_slider_el = document.getElementById('fashion-color-switch'+element);
    other_color_switch_slider_el = document.getElementById('fashion-color-limited-switch'+element);
  }
  const currentActive = color_switch_slider_el.querySelector('.sidebar--color-item.active');
  if (currentActive) {
    currentActive.classList.remove('active');
  }

  if (other_color_switch_slider_el) {
    other_color_switch_slider_el.querySelector('.sidebar--color-item.active')?.classList.remove('active');
  }
  const newActiveElement = color_switch_slider_el.querySelector(`[data-handle="${handle}"]`).parentElement;
  newActiveElement.classList.add('active');

 
  const colorName = color_switch_slider_el.querySelector(`[data-handle="${handle}"]`).getAttribute('data-bgcolor');

  
  if (!isLimited) {
    document.getElementById('limited-color-text' + element).innerHTML = "";
    document.getElementById('fashion-color-switch-item-title' + element).innerHTML = ` ${colorName}`;
    document.getElementById('regular-color-text' + element).innerHTML = ` ${colorName}`;
  } else {
    document.getElementById('fashion-color-switch-item-title' + element).innerHTML = "";
    document.getElementById('regular-color-text' + element).innerHTML = "";
    document.getElementById('limited-color-text' + element).innerHTML = ` ${colorName}`;
  }
}
